module.exports = "<p>\r\n  invalid-route works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_Components/invalid-route/invalid-route.component.html
// module id = 409
// module chunks = 1